module.exports = __webpack_public_path__ + "img/wp-ranking_jp.c6647e1.png";